import hasPerms from "../../utils/hasPerms";
import { AREA, AREA_PERMS } from "./constants";
import { getArea, updateSearchString } from "./searchString";
export const isAreaPortal = (a) => {
    const area = a || getArea();
    return area === AREA.PORTAL || area === AREA.TRASH_PORTAL;
};
export const isAreaListPortals = (a) => {
    const area = a || getArea();
    return area === AREA.PORTALS_LIST || area === AREA.TRASH_PORTALS_LIST;
};
export const isAreaTrash = (a) => {
    const area = a || getArea();
    return area.endsWith(AREA.TRASH);
};
export const filterAreasToPerms = (areas, permissions) => {
    return areas.filter((a) => {
        const perm = AREA_PERMS[a];
        if (!perm)
            return true;
        return hasPerms([perm], permissions);
    });
};
export const checkQueryArea = ({ history, search, permissions, }) => {
    const area = getArea();
    const myAccess = filterAreasToPerms(Object.values(AREA), permissions);
    const canEnterInArea = new Set(myAccess).has(area);
    if (!area || !canEnterInArea) {
        updateSearchString({
            history,
            search,
            area: myAccess[0] || null,
        });
    }
};
